var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#0d0d0d;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.334,13.42v2.3a1.531,1.531,0,0,1-1.669,1.531A15.147,15.147,0,0,1,9.06,14.9,14.925,14.925,0,0,1,4.468,10.3a15.147,15.147,0,0,1-2.35-6.636A1.531,1.531,0,0,1,3.641,2h2.3A1.531,1.531,0,0,1,7.468,3.316,9.828,9.828,0,0,0,8,5.467,1.531,1.531,0,0,1,7.66,7.082l-.972.972a12.246,12.246,0,0,0,4.592,4.592l.972-.972a1.531,1.531,0,0,1,1.615-.344,9.828,9.828,0,0,0,2.151.536,1.531,1.531,0,0,1,1.316,1.554Z",
    transform: "translate(-0.668 -0.559)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpPhoneIcon);
export default __webpack_public_path__ + "static/media/sign-up-phone-icon.a83d5b4daa063fbb2b7f25dbbde5e89c.svg";
export { ForwardRef as ReactComponent };